import React from 'react'
import Pagination from '../../components/Pagination'
export default () => (
  <Pagination />
)